import type * as Dialog from '@radix-ui/react-dialog';
import { ConfirmDialog } from '@ui/uikit/components/common/Dialog';

// TODO: instead of creating each time new confirm modal we should create provider like mui-confirm-modal
export const EmailRemoveConfirmDialog = ({
  onConfirm,
  ...props
}: Dialog.DialogProps & { onConfirm?: () => void }) => {
  return (
    <ConfirmDialog
      title={
        <>
          Are you sure you want
          <br />
          to remove emails?
        </>
      }
      description={
        <>
          Please make sure that a wallet or Telegram
          <br />
          is connected to your account.
        </>
      }
      {...props}
      onConfirm={onConfirm}
    />
  );
};
